import M_LX_REPORT from '@fql/lx_report';

// const isValidJson = (str) => {
//     try {
//         return JSON.parse(str);
//     } catch (e) {
//         return false;
//     }
// };

// 实例初始化
const M_DATA_REPORT = new M_LX_REPORT({
    mainSwitch: true,
    reportSwitch: true
});

// 判断是否为移动端
const isMobile = () => {
    let e1 = /\bfenqile_(ios|android)_(\d+\.\d+\.\d+)\b/.test(navigator.userAgent)
    let e2 = /\b(Android|iPhone|iPad|Mobile|Mobi|IEMobile)\b/i.test(navigator.userAgent)
    return e1 || e2;
};

// 数据上报
export const dataReport = (options = {}, extendInfo = {}) => {
    try {
        const pagePrefix = isMobile() ? 'FQL_MOB_PAGE' : 'FQL_WEB_PAGE';
        const hottag = `${pagePrefix}.${options.hottag || ''}`;
        // const userInfo = isValidJson(sessionStorage.getItem('userInfo') || '') || {};

        M_DATA_REPORT.pageReport({
            // 旧数据格式
            record_type: 2, // 页面行为
            event_pos: hottag, // 点击流
            event_pos_name: options.eventPosName, // 点击流的名字
            event_type: 1, // 行为类型 1：曝光；2：点击；3：截屏；
            extend_info: {
                ...extendInfo
            }, // 扩展信息
            // 新数据格式
            standard_extend_info: {
                extendInfo
            },
            event_case_code: hottag
        });
    } catch (error) {
        console.error(error);
    }
};